import { GroupDescriptor } from '@progress/kendo-data-query';

/**
 * Serializes group descriptors for OData queries.
 * Converts dots to slashes in field names to handle nested properties (e.g., prop1.childprop1 -> prop1/childprop1)
 */
export const serializeGroup = (
  groups: Array<GroupDescriptor>
): string[] => {
  return groups.map((group) => {
    // Convert dots to slashes for nested properties
    let hierarchy = group.field.split('.');
    if(hierarchy.length> 2) {
      hierarchy = hierarchy.map(s => 
         s.charAt(0).toUpperCase() + s.slice(1)
      );
      return hierarchy.join('/');
    }
    const fieldName = group.field.replace(/\./g, '/');
    return fieldName;
  });
};
